export default {
  create: {
    title: 'Agregar',
    subtitle: 'Juegos',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Juego',
    button: {
      add: 'Nuevo juego',
    },
  },
  list: {
    title: 'Number Square',
    subtitle: 'Lista',
    add: 'Nuevo juego',
  },
  card: {
    title: 'Number Square',
    actions: 'Acciones',
  },
  table: {
    title: 'Juegos activos',
    searchPlaceholder: 'Buscar por algo...',
  },
  form: {
    name: {
      label: 'Nombre:',
      placeholder: 'Ej: Number Square Nivel 1',
      invalid: 'El nombre es obligatorio',
    },
    showAnswer: {
      label: 'Mostrar respuesta',
    },
    colored: {
      label: 'Colorido',
    },
    maxValue: {
      label: 'Números disponibles:',
      option9: '1 hasta 9',
      option16: '1 hasta 16',
      option25: '1 hasta 25',
    },
    difficulty: {
      label: 'Dificultad:',
      easy: 'Fácil',
      medium: 'Medio',
      hard: 'Difícil',
      random: 'Aleatorio',
    },
    distribution: {
      checkboxLabel: 'Distribuir por porcentaje',
      tooltipText:
        'Los operadores matemáticos se distribuirán en el juego según los porcentajes definidos abajo.',
    },
    operators: {
      plus: 'Suma (+)',
      minus: 'Resta (-)',
      times: 'Multiplicación (×)',
      divide: 'División (÷)',
    },
  },
  button: {
    generate: 'Generar juego',
  },
  sidebar: {
    exportHint: 'Debe guardar antes de exportar.',
    defaultFileName: 'numberSquare',
  },
  alert: {
    generated: '¡Puzzle generado con éxito!',
    generateFailed: 'No fue posible generar el puzzle.',
    workerError: 'Error interno en la generación.',
    gameSaved: '¡Juego guardado con éxito!',
    workerErrors: {
      noCombinations:
        'No fue posible generar combinaciones con estos operadores. Inténtelo de nuevo.',
    },
  },
};
